<template>
  <div class="wrapper">
    <slot name="before"></slot>
    <div class="d-input" :class="{'d-input--focused': outline}">
      <slot name="start"></slot>
      <input
        v-datepicker="{minDate: now}"
        v-bind="$attrs"
        v-bind:value="persianDate"
        v-on:input="$emit('input', $event.detail.GregorianDate );"
        v-on:focus="outline=true"
        v-on:blur="outline=false"
      />
      <slot name="end"></slot>
    </div>
    <slot name="after"></slot>
  </div>
</template>
<script>
import moment from "moment-jalaali";
export default {
  inheritAttrs: false,
  name: "pdk-datepicker",
  props: ["value"],
  model: {
    prop: "value",
    event: "input",
  },
  data: () => ({
    outline: false,
    now: moment(),
  }),
  computed: {
    persianDate() {
      if (moment(this.value).isValid())
        return moment(this.value).format("jYYYY/jMM/jDD");
      return "";
    },
  },
};
</script>
<style scoped>
.wrapper {
  display: flex;
  align-items: center;
  height: 100%;
}

.wrapper * {
  box-sizing: border-box;
}

.d-input {
  align-items: center;
  display: flex;
  flex: 1 1 auto;
  flex-wrap: wrap;
  width: 100%;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
}

.d-input,
.d-input input {
  height: 100%;
}

.wrapper .d-input {
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5;
}

.wrapper .d-input input {
  height: calc(1.5em + 0.75rem);
  padding: 0.375rem 0.75rem;
}

.d-input input {
  font-size: 1rem;
  background-size: 25px 25px;
  background-position: right 10px center;
  background-repeat: no-repeat;
  color: #495057 !important;
  background-color: transparent;
  border-style: none;
  pointer-events: auto;
  flex: 1 1;
  margin-top: 0;
  min-width: 0;
  position: relative;
  line-height: 20px;
  max-width: 100%;
  width: 100%;
}

.d-input input:focus {
  outline: none;
}

.wrapper .d-input input {
  height: calc(1.5em + 0.75rem);
  padding: 0.375rem 0.75rem;
  
}
.d-input.d-input--focused {
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(128, 189, 255, 0.5);
  z-index:10000
}
</style>